export default function (app) {
  app.factory('klSubscriptionService', [
    '$http',
    function ($http) {
      function subscribe(
        ratePlans,
        account,
        paymentMethodId,
        paymentMethodType,
        options,
        licenseId,
        poNumber,
      ) {
        const data = mergeObjects(
          {},
          { ratePlans, account, paymentMethodId, paymentMethodType },
          options,
        );
        data.License_Id__c = licenseId;
        data.PurchaseOrderNumber__c = poNumber;
        return $http
          .post('/api/subscription', data)
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            return JSON.parse(e.data.message);
          });
      }
      function mergeObjects() {
        var resObj = {};
        for (var i = 0; i < arguments.length; i += 1) {
          var obj = arguments[i],
            keys = Object.keys(obj);
          for (var j = 0; j < keys.length; j += 1) {
            resObj[keys[j]] = obj[keys[j]];
          }
        }
        return resObj;
      }

      function cancel(subscriptionNumber) {
        return $http.put(`/webshop-api/subscriptions/${subscriptionNumber}/autoRenew`, {
          autoRenew: false,
        });
      }
      function cancelEnterprise(email, companyName, fullName, subscriptionId) {
        const data = { email: email, companyName: companyName, fullName: fullName };
        return $http.put(`/api/subscription/${subscriptionId}/cancelEnterprise`, data);
      }
      function reactivate(subscriptionNumber) {
        return $http.put(`/webshop-api/subscriptions/${subscriptionNumber}/autoRenew`, {
          autoRenew: true,
        });
      }

      function amend(subscriptionNumber, seats) {
        return $http.patch(`/webshop-api/subscriptions/${subscriptionNumber}`, { seats });
      }

      function previewSeatUpgrade(subscriptionNumber, seats) {
        return $http
          .patch(`/webshop-api/subscriptions/${subscriptionNumber}/previewSeatUpgrade`, { seats })
          .then((r) => r.data);
      }

      function decorateRatePlans(subscriptions) {
        for (let s = 0; s < subscriptions.length; s++) {
          const subscription = subscriptions[s];
          for (let i = 0; i < subscription.ratePlans.length; i++) {
            const ratePlan = subscription.ratePlans[i];
            for (let j = 0; j < ratePlan.ratePlanCharges.length; j++) {
              const ratePlanCharge = ratePlan.ratePlanCharges[j];
              if (
                ratePlanCharge.type == 'Recurring' &&
                !!ratePlanCharge.uom &&
                !!ratePlanCharge.quantity
              ) {
                ratePlan.quantity = ratePlanCharge.quantity;
                if (!ratePlan.ProductCode__c) {
                  ratePlan.ProductCode__c = subscription.productCode;
                }
                break;
              }
            }
          }
        }

        return subscriptions;
      }

      return {
        subscribe,
        cancel,
        cancelEnterprise,
        amend,
        reactivate,
        decorateRatePlans,
        previewSeatUpgrade,
      };
    },
  ]);
}
